// 导入组件
import intpuMore from './src/input-more.vue'

// 为组件提供 install 安装方法，供按需引入
intpuMore.install = function (Vue) {
  Vue.component(intpuMore.name, intpuMore)
}

// 默认导出组件
export default intpuMore
